/* Momoria diffuser offer v2 — behaviour. All copy comes from data-* on the root, set by the section. */
(function () {
  function init(root) {
    if (!root || root.dataset.mdo2Ready) return;
    root.dataset.mdo2Ready = '1';

    var d = root.dataset;
    var CHANGE = d.change || 'Change';
    var CLOSE = d.close || 'Close';
    var PICKH = d.pickh || 'Choose fragrance {n}';
    var GIFT_T = d.giftTitle || '';
    var GIFT_N = d.giftNote || '';
    var UP_T = d.upTitle || '';
    var UP_N = d.upNote || '';
    var PAIR = d.pair || 'Two {size} diffusers';
    var UPKEY = d.upkey || '200ml';
    var GIFT_S = d.giftSummary || '';
    var SAVEW = d.saveword || 'Save';

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var picker = q('[data-mdo2-picker]');
    var phead = q('[data-mdo2-phead]');
    var variant = q('[data-mdo2-variant]');
    var giftRow = q('[data-mdo2-giftrow]');
    var giftBox = q('[data-mdo2-gift]');
    var giftStep = q('[data-mdo2-giftstep]');
    var live = q('[data-mdo2-live]');
    var editing = null;

    function sizes() { return qa('[data-mdo2-size]'); }
    function chosen() {
      var s = sizes().filter(function (i) { return i.checked; });
      return s[0] || sizes()[0] || null;
    }

    /* ---------- gallery ---------- */
    var galMain = q('[data-mdo2-galmain]');
    qa('[data-mdo2-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (galMain && t.dataset.full) galMain.src = t.dataset.full;
        qa('[data-mdo2-thumb]').forEach(function (o) { o.classList.toggle('is-on', o === t); });
      });
    });

    /* ---------- fragrances ---------- */
    function paintChips() {
      var slotName = editing ? q('[data-mdo2-name="' + editing + '"]').textContent.trim() : '';
      qa('[data-mdo2-pick]').forEach(function (c) {
        c.classList.toggle('is-on', editing !== null && c.dataset.title === slotName);
        c.setAttribute('aria-pressed', c.classList.contains('is-on') ? 'true' : 'false');
      });
    }
    function openSlot(n) {
      editing = (editing === n) ? null : n;
      qa('[data-mdo2-slot]').forEach(function (s) {
        var on = editing !== null && +s.dataset.mdo2Slot === editing;
        s.classList.toggle('is-open', on);
        s.setAttribute('aria-expanded', on ? 'true' : 'false');
        var pill = s.querySelector('[data-mdo2-pilltext]');
        if (pill) pill.textContent = on ? CLOSE : CHANGE;
      });
      if (picker) picker.classList.toggle('is-open', editing !== null);
      if (phead && editing !== null) phead.textContent = PICKH.replace('{n}', '0' + editing);
      paintChips();
    }
    qa('[data-mdo2-slot]').forEach(function (s) {
      s.addEventListener('click', function () { openSlot(+s.dataset.mdo2Slot); });
    });
    qa('[data-mdo2-pick]').forEach(function (c) {
      c.addEventListener('click', function () {
        if (editing === null) return;
        var n = editing;
        q('[data-mdo2-name="' + n + '"]').textContent = c.dataset.title;
        q('[data-mdo2-tags="' + n + '"]').textContent = c.dataset.tags || '';
        q('[data-mdo2-desc="' + n + '"]').textContent = c.dataset.desc || '';
        var img = q('[data-mdo2-img="' + n + '"]');
        if (img && c.dataset.img) { img.src = c.dataset.img; img.alt = c.dataset.title; img.hidden = false; }
        q('[data-mdo2-prop="' + n + '"]').value = c.dataset.title;
        openSlot(n);
        render();
      });
    });

    /* ---------- size, price, gift ---------- */
    function render() {
      var s = chosen();
      if (!s) return;

      if (variant && s.dataset.variantId) variant.value = s.dataset.variantId;

      var price = q('[data-mdo2-price]');
      var comp = q('[data-mdo2-compare]');
      var hp = q('[data-mdo2-heroprice]');
      var hc = q('[data-mdo2-herocompare]');
      var bp = q('[data-mdo2-btnprice]');
      if (price) price.textContent = s.dataset.price || '';
      if (hp) hp.textContent = s.dataset.price || '';
      if (bp) bp.textContent = s.dataset.price || '';
      [comp, hc].forEach(function (el) {
        if (!el) return;
        if (s.dataset.compare) { el.textContent = s.dataset.compare; el.hidden = false; }
        else el.hidden = true;
      });
      var sav = q('[data-mdo2-save]');
      if (sav) {
        if (s.dataset.save) { sav.textContent = SAVEW + ' ' + s.dataset.save; sav.hidden = false; }
        else sav.hidden = true;
      }

      var eligible = s.dataset.cards === 'true';
      if (giftRow) {
        if (giftBox) {
          if (!eligible) giftBox.checked = false;
          giftBox.disabled = !eligible;
        }
        giftRow.classList.toggle('is-on', eligible && giftBox && giftBox.checked);
        giftRow.classList.toggle('is-upgrade', !eligible);
        var box = q('[data-mdo2-giftbox]');
        if (box) box.hidden = !eligible;
        var t = q('[data-mdo2-gifttitle]'), nn = q('[data-mdo2-giftnote]');
        if (t) t.innerHTML = eligible ? GIFT_T : UP_T;
        if (nn) nn.textContent = eligible ? GIFT_N : UP_N;
        if (giftStep) giftStep.classList.toggle('is-done', eligible && giftBox && giftBox.checked);
      }

      var n1 = q('[data-mdo2-name="1"]'), n2 = q('[data-mdo2-name="2"]');
      var sum = q('[data-mdo2-summary]'), sc = q('[data-mdo2-scents]');
      if (sum) sum.textContent = PAIR.replace('{size}', s.dataset.label || '');
      if (sc && n1 && n2) {
        sc.textContent = n1.textContent.trim() + ' · ' + n2.textContent.trim() +
          (eligible && giftBox && giftBox.checked ? ' · ' + GIFT_S : '');
      }
      if (live) live.textContent = (s.dataset.label || '') + ', ' + (s.dataset.price || '');
    }

    sizes().forEach(function (i) { i.addEventListener('change', render); });

    if (giftRow) {
      giftRow.addEventListener('click', function (e) {
        var s = chosen();
        if (s && s.dataset.cards !== 'true') {
          e.preventDefault();
          var target = sizes().filter(function (i) { return i.dataset.key === UPKEY; })[0] ||
            sizes().filter(function (i) { return i.dataset.cards === 'true'; })[0];
          if (target) {
            target.checked = true;
            if (giftBox) giftBox.checked = true;
            render();
            target.closest('.mdo2__size').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }
      });
    }
    if (giftBox) giftBox.addEventListener('change', render);

    /* ---------- Royal Mail arrival countdown ---------- */
    var arr = q('[data-mdo2-arrival]');
    if (arr && window.Intl && Intl.DateTimeFormat) {
      var HOL = (arr.dataset.holidays || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var CUT_H = parseInt(arr.dataset.cutoffHour, 10) || 0;
      var CUT_M = parseInt(arr.dataset.cutoffMinute, 10) || 0;
      var SAT_DISPATCH = arr.dataset.dispatchSaturday === 'true';
      var SUN_DELIVERY = arr.dataset.sundayDelivery === 'true';
      var TOMORROW_WORD = (arr.dataset.tomorrowWord || '').trim();
      var headEl = q('[data-mdo2-arrhead]');
      var HEAD_TPL = headEl ? headEl.textContent.trim() : '';

      /* read "now" as UK wall-clock time, whatever timezone the visitor is in */
      function ukNow() {
        var f = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
        });
        var o = {};
        f.formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') o[p.type] = p.value; });
        return {
          y: +o.year, m: +o.month, d: +o.day,
          hh: +(o.hour === '24' ? '00' : o.hour), mm: +o.minute, ss: +o.second
        };
      }
      function key(dt) {
        return dt.getUTCFullYear() + '-' +
          ('0' + (dt.getUTCMonth() + 1)).slice(-2) + '-' +
          ('0' + dt.getUTCDate()).slice(-2);
      }
      function isHoliday(dt) { return HOL.indexOf(key(dt)) !== -1; }
      function canDispatch(dt) {
        var w = dt.getUTCDay();
        if (isHoliday(dt)) return false;
        if (w >= 1 && w <= 5) return true;
        return SAT_DISPATCH && w === 6;
      }
      function canDeliver(dt) {
        var w = dt.getUTCDay();
        if (isHoliday(dt)) return false;
        if (w >= 1 && w <= 6) return true;
        return SUN_DELIVERY && w === 0;
      }
      function addDays(dt, n) {
        var c = new Date(dt.getTime());
        c.setUTCDate(c.getUTCDate() + n);
        return c;
      }

      var LONG = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
      var DAY = new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' });

      function tick() {
        var n = ukNow();
        var today = new Date(Date.UTC(n.y, n.m - 1, n.d));
        var beforeCutoff = (n.hh < CUT_H) || (n.hh === CUT_H && n.mm < CUT_M);

        var dispatch = new Date(today.getTime());
        if (!(beforeCutoff && canDispatch(dispatch))) dispatch = addDays(dispatch, 1);
        var guard = 0;
        while (!canDispatch(dispatch) && guard < 30) { dispatch = addDays(dispatch, 1); guard++; }

        var arrive = addDays(dispatch, 1);
        guard = 0;
        while (!canDeliver(arrive) && guard < 30) { arrive = addDays(arrive, 1); guard++; }

        var deadline = new Date(Date.UTC(
          dispatch.getUTCFullYear(), dispatch.getUTCMonth(), dispatch.getUTCDate(), CUT_H, CUT_M, 0
        ));
        var nowUtc = new Date(Date.UTC(n.y, n.m - 1, n.d, n.hh, n.mm, n.ss));
        var left = Math.max(0, Math.floor((deadline - nowUtc) / 1000));
        var dd = Math.floor(left / 86400);
        var hh = Math.floor((left % 86400) / 3600);
        var mi = Math.floor((left % 3600) / 60);
        var se = left % 60;

        var c = q('[data-mdo2-count]');
        var da = q('[data-mdo2-arrdate]');
        if (c) c.textContent = (dd > 0 ? dd + 'd ' : '') + hh + 'h ' + mi + 'm ' + se + 's';
        if (da) da.textContent = LONG.format(arrive);
        /* say "tomorrow" only when it genuinely is the next day; otherwise name the weekday */
        var dayWord = DAY.format(arrive);
        if (TOMORROW_WORD && key(arrive) === key(addDays(today, 1))) dayWord = TOMORROW_WORD;
        if (headEl && HEAD_TPL) headEl.textContent = HEAD_TPL.replace('{day}', dayWord);
      }
      tick();
      setInterval(tick, 1000);
    }

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mdo2]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme Editor re-renders the section without a page load */
  document.addEventListener('shopify:section:load', boot);
})();